<template>
  <div class="carrier-info">
    <el-row v-if="!isOrderDemoVersion" >
      <el-col  :md="8" :sm="24">
        <a-form-model-item
          label="供应商名称"
          :colon="false"
          :label-col="{span: 6}"
          :wrapper-col="{span: 16}"
          prop="carrierName"
        >
          <a-input
            v-model="form.carrierName"
            :max-length="30"
            placeholder="请输入供应商名称"
          />
        </a-form-model-item>
      </el-col>
      <el-col :md="8" :sm="24">
        <a-form-model-item
          label="生产厂商"
          :colon="false"
          :label-col="{span: 6}"
          :wrapper-col="{span: 16}"
        >
          <a-input
            v-model="form.manufacturer"
            :max-length="30"
            placeholder="请输入生产厂商"
          />
        </a-form-model-item>
      </el-col>
   </el-row>
    <a-table
      :columns="CarrierColumns"
      :data-source="form.driverInfoReqList"
      :pagination="false"
      size="small"
      :scroll="{ x: 'auto'}"
      :row-key="(record, index) => index"
      class="carrier-table"
    >
      <template slot="driverName" slot-scope="text, record">
        <a-form-model-item>
          <a-input
            v-model="record.driverName"
            :max-length="30"
            placeholder="请输入司机姓名"
          />
        </a-form-model-item>
      </template>
      <template slot="driverPhone" slot-scope="text, record, index">
        <a-form-model-item
          :prop="`carrierInfoReq.driverInfoReqList.${index}.driverPhone`"
          :rules="[
            { pattern: /^\d{1,12}$/, message: '请输入正确的手机号', trigger: 'blur' }
          ]"
        >
          <a-input
            v-model="record.driverPhone"
            :max-length="FormValidator.Phone.MAX_LENGTH"
            placeholder="请输入司机手机号"
          />
        </a-form-model-item>
      </template>
      <template slot="licensePlate" slot-scope="text, record">
        <a-form-model-item>
          <a-input
            v-model="record.licensePlate"
            :max-length="30"
            placeholder="请输入车牌号"
          />
        </a-form-model-item>
      </template>
      <template slot="carTypeId" slot-scope="text, record, index">
        <a-form-model-item>
          <a-select
            key="carSettingName"
            v-model="record.carTypeId"
            show-search
            allow-clear
            placeholder="请选择车型"
            style="width: 100%"
            :filter-option="filterOption"
            @change="val => changeCarType(val,index)"
          >
            <a-select-option
              v-for="item in allCarTypeList"
              :key="item.id"
              :value="item.id"
            >
              {{item.carSettingName}}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </template>
      <template slot="timeRange" slot-scope="text, record">
        <a-form-model-item>
          <a-range-picker
           v-model="record.timeRange"
           format="YYYY-MM-DD HH:mm"
           value-format="YYYY-MM-DD HH:mm"
           show-time
          />
        </a-form-model-item>
      </template>
      <template slot="action" slot-scope="text, record, index">
        <span v-if="form.driverInfoReqList.length < 9" class="add-btn" @click="onAdd">添加</span>
        <span v-if="form.driverInfoReqList.length > 1" class="delete-btn" @click="onDelete(index)">删除</span>
      </template>
    </a-table>
  </div>
</template>

<script>
import FormValidator from '@/constants/formValidator'
import { mapGetters } from 'vuex'
import { CarrierColumns } from '../constant';

export default {
  name: 'CarrierInfo',
  model: {
    prop: "form",
    event: "change",
  },
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    allCarTypeList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      CarrierColumns,
      FormValidator,
    }
  },
  computed:{
    ...mapGetters('orderRules', ['isOrderDemoVersion']),
  },
  methods: {
    onAdd() {
      this.form.driverInfoReqList.push({})
    },
    onDelete(index) {
      this.form.driverInfoReqList.splice(index, 1);
    },
    filterOption(val, option) {
      const carName = option.componentOptions?.children?.[0]?.text || ''
      return carName.includes(val)
    },
    changeCarType(val, index) {
      const current = this.allCarTypeList.find(item => item.id === val) || {}
      this.form.driverInfoReqList[index].carType = current.carSettingName || undefined
      this.form.driverInfoReqList[index].carTypeId = current.id || undefined
    },
  }
}
</script>

<style lang="less" scoped>
.carrier-table {
  padding: 0 32px;
  /deep/ .ant-form-item {
    margin-bottom: 0 !important;
    .ant-form-item-control-wrapper {
      width: 100%;
    }
  }
  .add-btn, .delete-btn {
    color: #06b880;
    cursor: pointer;
  }
  .add-btn {
    margin-right: 15px;
  }
}
</style>
